import { mapActions, mapGetters } from "vuex";
import { saveAs } from "file-saver";
export const previewProofHandler = {
  data() {
    return {};
  },
  computed: {
    ...mapGetters("common", ["plans", "plan"]),
    ...mapGetters("plansMembers", ["options", "planOptions", "planIdentity"]),
  },
  methods: {
    async previewProof(proof) {
      // this.loading = true;
      console.log("preview-proof", proof);

      // const getFileBase64 = (fileSegment) => {
      //   // eslint-disable-next-line no-async-promise-executor, no-unused-vars
      //   return new Promise(async (resolve, reject) => {
      //     try {
      //       let file = (await this.getFile(fileSegment.PhysicalFileId)).data;
      //       if (file[0] === '"') file = file.slice(1, -1);
      //       fileSegment.Base64 = file;
      //       fileSegment.FileExtension = this.$helpers.fileExtension(
      //         fileSegment.FileName
      //       );
      //       resolve(fileSegment);
      //     } catch (error) {
      //       reject(error);
      //     }
      //   });
      // };

      // try {
      // await Promise.all(proof.FileSegments.map((fs) => getFileBase64(fs)));
      // this.fileItems = proof;
      // this.preview = true;

      for (const file of proof.FileSegments) {
        // console.log(file)
        try {
          this.loading = true;
          let isBinary = false;

          let base64File = (await this.getFile(file.PhysicalFileId)).data;
          if (base64File[0] === '"') {
            base64File = base64File.slice(1, -1);
          }
          file.Base64 = base64File;
          file.FileExtension = this.$helpers.fileExtension(file.FileName);
          let blob = null;
          if (file.FileExtension.toLowerCase() === "pdf") {
            blob = this.$files.b64toBlob(base64File, "application/pdf");
          } else if (file.FileExtension.toLowerCase() === "png") {
            blob = this.$files.b64toBlob(base64File, "image/png");
          } else if (
            file.FileExtension.toLowerCase() === "jpg" ||
            file.FileExtension.toLowerCase() === "jpeg"
          ) {
            blob = this.$files.b64toBlob(base64File, "image/jpeg");
          } else if (file.FileExtension.toLowerCase() === "heic") {
            blob = this.$files.b64toBlob(base64File, "image/heic");
          } else if (file.FileExtension.toLowerCase() === "txt") {
            blob = this.$files.b64toBlob(base64File, "text/plain");
          } else {
            try {
              isBinary = true;
              blob = this.$files.b64toBlob(base64File);
            } catch {
              blob = null;
            }
          }
          if (blob === null) {
            // console.log("window open ")
            const w = window.open();
            const everythingLoaded = setInterval(() => {
              // console.log("interval 10 passed: ", w.document.readyState);
              if (/loaded|complete/.test(w.document.readyState)) {
                clearInterval(everythingLoaded);
                const timeout = setTimeout(() => {
                  clearTimeout(timeout);
                  w.document.title = proof.UploadName;

                  const newDiv = w.document.createElement("div");
                  const newContent = w.document.createTextNode(
                    `${proof.UploadName} - No Preview Available`
                  );

                  newDiv.style =
                    "font-size:20px;margin-left:auto;margin-right:auto;background-color:white;color:black;margin-top:20px;z-index:1";

                  newDiv.appendChild(newContent);

                  w.document.body.prepend(newDiv);
                }, 10);
              }
            }, 10);
          } else {
            if (isBinary) {
              saveAs(blob, file.FileName);
              return;
            }
            const url = URL.createObjectURL(blob);
            const w = window.open(url, "_blank");
            const everythingLoaded = setInterval(() => {
              // console.log("interval 10 passed: ", w.document.readyState);
              if (/loaded|complete/.test(w.document.readyState)) {
                clearInterval(everythingLoaded);
                const timeout = setTimeout(() => {
                  clearTimeout(timeout);
                  w.document.title = proof.UploadName;
                  if (
                    file.FileExtension.toLowerCase() === "png" ||
                    file.FileExtension.toLowerCase() === "jpg" ||
                    file.FileExtension.toLowerCase() === "jpeg" ||
                    file.FileExtension.toLowerCase() === "txt"
                  ) {
                    let link = w.document.createElement("link");
                    link.type = "text/css";
                    link.rel = "stylesheet";
                    w.document.head.appendChild(link);
                    link.href =
                      "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0";

                    const newDiv = w.document.createElement("div");
                    const newContent = w.document.createTextNode(
                      proof.UploadName
                    );

                    const rotateRightBtn = w.document.createElement("span");
                    rotateRightBtn.setAttribute(
                      "class",
                      "material-symbols-outlined"
                    );
                    rotateRightBtn.innerHTML = "rotate_right"; // some text to improve visualization
                    rotateRightBtn.id = "rotate-right";
                    rotateRightBtn.style = "cursor:pointer";

                    const rotateLeftBtn = w.document.createElement("span");
                    rotateLeftBtn.setAttribute(
                      "class",
                      "material-symbols-outlined"
                    );
                    rotateLeftBtn.innerHTML = "rotate_left"; // some text to improve visualization
                    rotateLeftBtn.id = "rotate-left";
                    rotateLeftBtn.style = "cursor:pointer";

                    newDiv.style =
                      "font-size:20px;margin-left:auto;margin-right:auto;background-color:white;color:black;margin-top:20px;z-index:1";
                    if (file.FileExtension.toLowerCase() !== "txt") {
                      newDiv.appendChild(rotateLeftBtn);
                    }
                    newDiv.appendChild(newContent);
                    if (file.FileExtension.toLowerCase() !== "txt") {
                      newDiv.appendChild(rotateRightBtn);
                    }

                    w.document.body.prepend(newDiv);

                    var script = w.document.createElement("script");
                    script.type = "text/javascript";
                    script.text = `function rotateRight(e) {
                    const rotated = document.getElementsByTagName('img');
                      if (rotated.length > 0) {
                        let degrees = 0;
                        for (i=0;i<=countRight;i++) {
                          degrees+= 90;
                        }
                        degrees = degrees.toString() + 'deg'
                        rotated[0].style.transform = 'rotate('+degrees+')';
                        countRight++;
                        countLeft--;
                        if (countRight === 4) {
                          countRight = 0;
                        }
                        if (countLeft < 0) {
                          countLeft = 4 + countLeft;
                        }
                      }
                      e.stopPropagation();
                    };
                    function rotateLeft(e) {
                      const rotated = document.getElementsByTagName('img');
                        if (rotated.length > 0) {
                          let degrees = 0;
                          for (i=0;i<=countLeft;i++) {
                            degrees-= 90;
                          }
                          degrees = degrees.toString() + 'deg';
                          rotated[0].style.transform = 'rotate('+degrees+')';
                          countLeft++;
                          countRight--;
                          if (countLeft === 4) {
                            countLeft = 0;
                          }
                          if (countRight < 0) {
                            countRight = 4 + countRight;
                          }
                        }
                        e.stopPropagation();
                      };
                    var countLeft = 0;
                    var countRight = 0;
                    document.getElementById('rotate-right').addEventListener('click', rotateRight);
                    document.getElementById('rotate-left').addEventListener('click', rotateLeft)`;
                    w.document.body.appendChild(script);
                  }
                }, 10);
              }
            }, 10);
          }

          // window.open(
          //   `#/proofs/${encodeURIComponent(
          //     proof.UploadName
          //   )}/${encodeURIComponent(file.FileName)}/${file.PhysicalFileId}`,
          //   "_blank"
          // );
        } catch (error) {
          this.errors.push({ file: file, error: error });
        } finally {
          this.loading = false;
        }
      }
      // } catch (error) {
      //   console.log(error);
      // } finally {
      //   this.loading = false;
      // }
    },
  },
};
